import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import { FaSearch } from "react-icons/fa";
import arrowDown from "../../../Assets/svg/arrow-down.svg";
import arrowUp from "../../../Assets/svg/arrow-up.svg";
import ModalCloseIcon from "../../../Assets/svg/close-modal.svg";
import { useNavigate } from "react-router-dom";
import "./help.css";
import { getApi } from "../api-client";

export default function HelpQuestions() {
  const adminApiUrl = process.env.REACT_APP_ADMIN_API_URL;
  const navigate = useNavigate();
  const [faqList, setFaqList] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    getFAQList();
  }, []);

  const getFAQList = async () => {
    try {
      const response = await getApi(adminApiUrl + `help?application=Tickgo`);
      if (response.success === true) {
        setFaqList(
          response.data.map((item) => ({
            ...item,
            expand: false,
          }))
        );
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    }
  };

  const filteredFaqs = faqList.filter(
    (item) =>
      (search !== "" &&
        item.question?.toLowerCase().includes(search.toLowerCase())) ||
      search === ""
  );

  return (
    <Container fluid className="help-container">
      <div className="help-wrapper">
        <div className="help-title">Frequently asked questions</div>
        <div className="help-subtitle">
          These are the most commonly asked questions about Mawalog suite.
        </div>
        <div className="help-ai-text">
          Can’t wait what you’re looking for? Chat with our AI
        </div>

        <div className="search-wrapper">
          <div className="search-box">
            <FaSearch className="search-icon" />
            <input
              type="text"
              className="form-control search-input"
              placeholder="Search questions..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </div>

        <div className="faq-container">
          <div className="faq-count">
            Total questions : {filteredFaqs.length}
          </div>

          <div className="faq-list mb-3">
            {filteredFaqs.map((item, index) => (
              <div
                key={"question" + index}
                className="faq-item"
                onClick={() => {
                  const temp = [...faqList];
                  const idx = temp.findIndex((q) => q.id === item.id);
                  if (idx > -1) {
                    temp[idx].expand = !temp[idx].expand;
                    setFaqList(temp);
                  }
                }}
              >
                <div className="faq-header">
                  <div
                    className={
                      item.expand
                        ? "faq-question-active"
                        : "faq-question"
                    }
                  >
                    {item.question}
                  </div>
                  <img src={item.expand ? arrowUp : arrowDown} alt="Arrow" />
                </div>

                {item.expand && (
                  <div className="faq-answer">{item.answer}</div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="help-close-wrapper" onClick={() => navigate(-1)}>
        <img
          src={ModalCloseIcon}
          alt="Close"
          className="help-close-icon"

        />
      </div>
    </Container>
  );
}
